import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { Col, Container, Row } from 'react-bootstrap';
import JobRoleDetails from './jobRoleDetails';
import ExperienceIcon from '../../../../../assets/images/Ic_work position.png';

const WorkExperinceInfo = ({ jobRoles = [], careerGaps = [] }) => {
  const [showAll, setShowAll] = useState(false);
  const extendedJobRoles = [
    ...jobRoles,
    ...(careerGaps.length > 0 ? careerGaps.map((gap) => ({ isCareerGap: true, ...gap })) : [])
  ];
  const visibleJobRoles = showAll ? extendedJobRoles : extendedJobRoles.slice(0, 4);
  return (
    <Container className="pt-2 work-experience-work-container">
      <Row>
        <Col>
          <h3 className="candidate-heading">
            Work Experience ({extendedJobRoles.length})
            <img src={ExperienceIcon} alt="Experience" className="profile-work-experience-nav-icon" />
          </h3>
          <Container>
            {visibleJobRoles.map((jobRole, index) => (
              <JobRoleDetails jobDetail={jobRole} index={index} isCurrentRole={index === 0 && !jobRole.isCareerGap}></JobRoleDetails>
            ))}
          </Container>
          {extendedJobRoles.length > 4 && (
            <Row>
              <Col>
                <a
                  className="experience-view-all"
                  onClick={() => setShowAll((prev) => !prev)}
                >
                  {showAll ? 'View Less' : 'View All'}&nbsp;
                  <FontAwesomeIcon icon={showAll ? faChevronUp : faChevronDown} />
                </a>
              </Col>
            </Row>
          )}
        </Col>
      </Row>

    </Container>
  );
};

export default WorkExperinceInfo;